/**
 * Links a failed request to the error toast the api client raised for it.
 *
 * The response interceptor (lib/api.ts) toasts every failure it handles, and a caller that has its
 * own wording calls `getErrorMessage(error, { toast: true })` on the same error — so the customer
 * got two toasts for one failure. Remembering the interceptor's toast id against the error lets the
 * caller's toast replace that one in place: one toast, carrying the caller's more specific message.
 *
 * A WeakMap rather than a property on the error, so nothing is added to an object other code
 * inspects, and an error that is collected takes its entry with it.
 */
const toastIds = new WeakMap<object, string | number>();

export function rememberApiErrorToast(
  error: unknown,
  toastId: string | number,
): void {
  if (typeof error === "object" && error !== null) {
    toastIds.set(error, toastId);
  }
}

export function apiErrorToastId(error: unknown): string | number | undefined {
  return typeof error === "object" && error !== null
    ? toastIds.get(error)
    : undefined;
}
